import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { PauseIcon } from '@root/shared/ui-kit/icons'

import type { ClassNameProps } from '@root/shared/react'
import type { RuleSet } from 'styled-components'

export type PausedBadgeVariant = 'full' | 'icon'
type PausedBadgeProps = {
  paused: boolean
  variant?: PausedBadgeVariant
  textCss?: RuleSet<object>
} & ClassNameProps

export const PausedBadge: React.FC<PausedBadgeProps> = ({
  className,
  paused,
  textCss,
  variant = 'full',
}) => {
  const { t } = useTranslation()
  return (
    <Paused className={className} data-paused={paused}>
      <PauseIcon size={10} />
      {variant === 'full' ? (
        <Text css={textCss}>{t('common.paused')}</Text>
      ) : undefined}
    </Paused>
  )
}
const Text = styled.span``

const Paused = styled.div`
  color: var(--warning-9);
  background: rgba(var(--warning-9-rgb), 0.25);
  border-radius: 6px;

  display: flex;
  height: 20px;
  padding: 5px 6px;
  align-items: center;
  gap: 2px;

  text-align: right;
  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
  opacity: 0;
  white-space: nowrap;

  transition: opacity 0.1s ease-in-out;

  &[data-paused='true'] {
    opacity: 1;
  }

  background: none;
  border: 1px solid rgba(var(--warning-9-rgb), 0.25);
`
